// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1h1D6","questions":"styles_questions__3-hgw","footer":"styles_footer__2iROy"};